import { takeLatest, put, fork } from "redux-saga/effects";
import { AxiosResponse } from "axios";
import { PatientDetailsOfLeftcard } from "../../Apis/AuthApiServices";
import {
  loadingPatientDetails,
  setPatientDetails,
} from "../Slice/PatientDetailsSlice";

function* onLoadPatientDetailsAsync({ payload }: any) {
  const params = new URLSearchParams();
  let patientId: any = sessionStorage.getItem("patientId");
  params.append("patientId", patientId);

  try {
    const result: AxiosResponse = yield PatientDetailsOfLeftcard(params);
    if (result?.data?.digitalRxStatusCode === 200) {
      yield put(
        setPatientDetails({
          AllPatientDetails: result?.data?.response[0],
          error: false,
          isLoading: false,
        })
      );
    } else {
      yield put(
        setPatientDetails({
          AllPatientDetails: {},
          error: true,
          isLoading: false,
          message: result?.data?.digitalRxStatusMessage,
        })
      );
    }
  } catch (error) {
    yield put(
      setPatientDetails({
        AllPatientDetails: {},
        error: true,
        isLoading: false,
        message: "Try Again After Some Time!",
      })
    );
  }
}

function* onLoadPatientDetails() {
  yield takeLatest(loadingPatientDetails.type, onLoadPatientDetailsAsync);
}

const PatientDetailsSaga = [fork(onLoadPatientDetails)];

export default PatientDetailsSaga;
